import { render, staticRenderFns } from "./XDNFeaturesDialog.vue?vue&type=template&id=1eb8e81a&"
import script from "./XDNFeaturesDialog.vue?vue&type=script&lang=ts&"
export * from "./XDNFeaturesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports